module.exports = __webpack_public_path__ + "static/media/BGMobile.11d318a1.svg";